import { Outlet } from "react-router";
import { ClientsProvider } from "./Clients/ClientsContext";

export default function Reseller() {
  return (
    <ClientsProvider>
      <Outlet />
    </ClientsProvider>
  );
}
